import configurator from './modules/configurator';

import basket from './modules/basket';

import customer from './modules/customer';

export default {
    configurator,
    basket,
    customer
};

